import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LogoGenState {
  fileName: string;
  isSaved: boolean;
  tempLogoUrl: string;
  style: string;
  companyName: string;
  companyDescription: string;
  industry: string;
  tone: string;
  color: string;
  negativePrompt: string;
}

const initialState: LogoGenState = {
  fileName: 'Untitled 1',
  isSaved: false,
  tempLogoUrl: '',
  style: '',
  companyName: '',
  companyDescription: '',
  industry: '',
  tone: '',
  color: '',
  negativePrompt: '',
};

const logoGenSlice = createSlice({
  name: 'logoGen',
  initialState,
  reducers: {
    setFileName: (state, action: PayloadAction<{ fileName: string }>) => {
      state.fileName = action.payload.fileName;
    },
    saveFile: (state, action: PayloadAction<{ fileSaved: boolean }>) => {
      state.isSaved = action.payload.fileSaved;
    },
    saveLogoInfo: (
      state,
      action: PayloadAction<{
        tempLogoUrl: string;
        style: string;
        companyName: string;
        companyDescription: string;
        industry: string;
        tone: string;
        color: string;
        negativePrompt: string;
      }>
    ) => {
      state.tempLogoUrl = action.payload.tempLogoUrl;
      state.style = action.payload.style;
      state.companyName = action.payload.companyName;
      state.companyDescription = action.payload.companyDescription;
      state.industry = action.payload.industry;
      state.tone = action.payload.tone;
      state.color = action.payload.color;
      state.negativePrompt = action.payload.negativePrompt;
    },
  },
});

export const { setFileName, saveFile, saveLogoInfo } = logoGenSlice.actions;
export default logoGenSlice.reducer;